var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.552 7.749c0-.217-.008-.428-.018-.636A9.822 9.822 0 0 0 24 4.559v-.001c-.893.391-1.843.651-2.835.777a4.894 4.894 0 0 0 2.165-2.719 9.845 9.845 0 0 1-3.12 1.191 4.919 4.919 0 0 0-8.511 3.364c0 .39.033.765.114 1.122-4.09-.2-7.71-2.16-10.142-5.147a4.962 4.962 0 0 0-.674 2.487c0 1.704.877 3.214 2.186 4.089A4.863 4.863 0 0 1 .96 9.116v.054a4.943 4.943 0 0 0 3.942 4.835c-.752.206-1.678.198-2.221.078.637 1.948 2.447 3.381 4.597 3.428a9.89 9.89 0 0 1-6.101 2.098c-.403 0-.79-.018-1.177-.067a13.856 13.856 0 0 0 7.548 2.208c9.054 0 14.004-7.5 14.004-14.001z",
    fill: "#55acee"
  })));
}

export default SvgTwitter;